import io from 'socket.io-client';

export class SocketIOServiceClass {

    public initialized = false;
    public sockets = {
        backend: undefined as any,
        platform: undefined as any,
    };

    public init(): void {
        this.sockets.backend = io(window.location.origin, {
            path: '/-/api/socket.io',
        });
        this.initialized = true;

        this.sockets.backend.on('connect_error', (e: any) => {
            console.error('Websocket connection error', e);
        });
    }
}

export const SocketIOService = new SocketIOServiceClass();
